module.exports = __webpack_public_path__ + "static/media/UserMen.28b79bb5.svg";